import * as API from '@/services/API';

export default {
  get(id) {
    return API.apiClient.get(`/staff-types/${id}`);
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/staff-types/${query}`);
  },
  async delete(id) {
    return API.apiClient.delete(`/staff-types/${id}`);
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/staff-types`, data);
    } else {
      return API.apiClient.put(`/staff-types/${id}`, data);
    }
  },
  search(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/staff-types/search${query}`);
  }
};
